var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6012 2.27247C16.7538 1.90918 17.2462 1.90918 17.3988 2.27247L18.5085 4.91459C18.5718 5.06511 18.7075 5.16835 18.8638 5.18478L21.6073 5.4731C21.9845 5.51274 22.1367 6.00294 21.8538 6.26711L19.7961 8.18835C19.6789 8.29781 19.6271 8.46485 19.6604 8.62552L20.2463 11.4458C20.3268 11.8336 19.9285 12.1366 19.601 11.9366L17.2196 10.4818C17.0839 10.399 16.9161 10.399 16.7804 10.4818L14.399 11.9366C14.0715 12.1366 13.6732 11.8336 13.7537 11.4458L14.3396 8.62552C14.3729 8.46485 14.3211 8.29781 14.2039 8.18835L12.1462 6.26711C11.8633 6.00294 12.0155 5.51274 12.3927 5.4731L15.1362 5.18478C15.2925 5.16835 15.4282 5.06511 15.4915 4.91459L16.6012 2.27247Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.7163L17 12.1054L15.1809 13.2166C13.5771 14.1964 11.9752 12.6327 12.2851 11.1408L12.7534 8.88624L11.1225 7.36348C10.75 7.01561 10.5512 6.55532 10.5135 6.08631C10.0489 5.92563 9.5283 5.9893 9.10811 6.27732L2.70811 10.6642C2.26551 10.9675 2 11.476 2 12.0203V20.3666C2 21.2687 2.71634 22 3.6 22H6.8V18.7332C6.8 16.929 8.23269 15.4664 10 15.4664C11.7673 15.4664 13.2 16.929 13.2 18.7332V22H16.4C17.2837 22 18 21.2687 18 20.3666V12.7163Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseRating);
export default __webpack_public_path__ + "static/media/house-rating.695a9ab80498d64dfbb20c2a1ac79c57.svg";
export { ForwardRef as ReactComponent };